import React from 'react';

export const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M5.7 13.7L5 13l4.6-4.6L5 3.7l.7-.7 5.3 5.3-5.3 5.4z"/></svg>
);

export const ChevronDown = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M2.3 5.3L3 4.6 8 9.6l5-5 .7.7L8 11 2.3 5.3z"/></svg>
);

export const FileIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" style={{ opacity: 0.7 }}>
    <path d="M13 4H9.4L8 2.6 7.6 2H3c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z" fill="none" stroke="currentColor" strokeWidth="1"/>
    <path d="M3.5 3h4l1.5 1.5H13v8.5H3V3z" fill="none" stroke="currentColor" strokeWidth="0.8"/>
  </svg>
);

export const FolderIcon: React.FC<{ open: boolean }> = ({ open }) => (
  open ? (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="#dcb67a">
      <path d="M1.5 14h12l1.5-7H7.5l-1-2h-5l-1 2v7z"/>
      <path d="M1.5 5V3h5l1 2" fill="none" stroke="#dcb67a" strokeWidth="0.5"/>
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="#dcb67a"><path d="M1.5 13V3h5l1 2H14v8H1.5z"/></svg>
  )
);

export const NewFileIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M12 3H8.4L7 1.6 6.6 1H2c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1z" fill="none" stroke="currentColor" strokeWidth="0.8"/>
    <path d="M8 5v6M5 8h6" strokeWidth="1.2" stroke="currentColor"/>
  </svg>
);

export const NewFolderIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M14 5H7.5l-1-2h-5v10h13V5z" fill="none" stroke="currentColor" strokeWidth="0.8"/>
    <path d="M10 7v4M8 9h4" strokeWidth="1.2" stroke="currentColor"/>
  </svg>
);

export const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path d="M11 3h2v1H3V3h2l1-1h4l1 1zM4 5h8l-.5 9h-7L4 5z" fill="none" stroke="currentColor" strokeWidth="0.8"/>
  </svg>
);
